import type { HeaderAlertsPortalDOMProps } from './HeaderAlerts.types';

import ComponentPortals from '../../../common/components/molecules/ComponentPortals';
import HeaderAlerts from './HeaderAlerts';

const HeaderAlertsPortal = () => {
    return (
        <ComponentPortals
            cmpName="HeaderAlerts"
            render={(domProps: HeaderAlertsPortalDOMProps) => (
                <HeaderAlerts alerts={domProps.alerts} />
            )}
        />
    );
};

export default HeaderAlertsPortal;
